import { create } from "zustand";
import { devtools } from "zustand/middleware";
import axios from "axios";

const initialState = {
  staffMinutes: [],
  gettingStaffMinutes: false,
  gettingStaffMinutesError: {},

  staffMinuteDetails: {},
  gettingStaffMinuteDetails: false,
  getStaffMinuteDetailsError: {},

  createdStaffMinute: null,
  creatingStaffMinute: false,
  creatingStaffMinuteError: {},

  updatedStaffMinute: null,
  updatingStaffMinute: false,
  updatingStaffMinuteError: {},

  deletedStaffMinute: null,
  deletingStaffMinute: false,
  deletingStaffMinuteError: {},

  approvingStaffMinute: false,
  approvedStaffMinute: null,
  approvingStaffMinuteError: {},

  checkingStaffMinute: false,
  checkedStaffMinute: null,
  checkingStaffMinuteError: {},

  showCreateStaffMinute: false,
  staffMinuteToEdit: null,
  showStaffMinuteDetails: false,
  staffMinuteDetailsRecord: null,

  creating: true
};

const store = (set, get) => ({
  ...initialState,

  getStaffMinutes: async () => {
    set({ gettingStaffMinutes: true, gettingStaffMinutesError: {} });
    try {
      const res = await axios.get("/administration/staff-minutes");
      set({ staffMinutes: res.staffMinutes });
    } catch (error) {
      set({ gettingStaffMinutesError: error });
    } finally {
      set({ gettingStaffMinutes: false });
    }
  },

  getStaffMinuteDetails: async (id) => {
    set({ gettingStaffMinuteDetails: true, getStaffMinuteDetailsError: {} });
    try {
      const res = await axios.get(`/administration/staff-minutes/${id}`);
      set({ staffMinuteDetails: res.data });
    } catch (error) {
      set({ getStaffMinuteDetailsError: error });
    } finally {
      set({ gettingStaffMinuteDetails: false });
    }
  },

  createStaffMinute: async (data) => {
    set({ creatingStaffMinute: true, creatingStaffMinuteError: {}, createdStaffMinute: null });
    try {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value);
      });
      const res = await axios.post("/administration/staff-minutes", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      set({ createdStaffMinute: res.data });
      get().getStaffMinutes();
      get().setCreatingStaffMinute(false, false, null);
    } catch (error) {
      set({ creatingStaffMinuteError: error });
    } finally {
      set({ creatingStaffMinute: false });
    }
  },

  updateStaffMinute: async (id, data) => {
    set({ updatingStaffMinute: true, updatingStaffMinuteError: {}, updatedStaffMinute: null });
    try {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value);
      });
      const res = await axios.put(`/administration/staff-minutes/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      set({ updatedStaffMinute: res.data });
      get().getStaffMinutes();
    } catch (error) {
      set({ updatingStaffMinuteError: error });
    } finally {
      set({ updatingStaffMinute: false });
    }
  },

  deleteStaffMinute: async (id) => {
    set({ deletingStaffMinute: true, deletingStaffMinuteError: {}, deletedStaffMinute: null });
    try {
      const res = await axios.delete(`/administration/staff-minutes/${id}`);
      set({ deletedStaffMinute: res.data });
      get().getStaffMinutes();
    } catch (error) {
      set({ deletingStaffMinuteError: error });
    } finally {
      set({ deletingStaffMinute: false });
    }
  },

  approveStaffMinute: async (id, data = {}) => {
    set({ approvingStaffMinute: true, approvingStaffMinuteError: {}, approvedStaffMinute: null });
    try {
      const res = await axios.patch(`/administration/staff-minutes/approve/${id}`, data);
      set({ approvedStaffMinute: res.data });
      get().getStaffMinutes();
      get().getStaffMinuteDetails(id);
    } catch (error) {
      set({ approvingStaffMinuteError: error });
    } finally {
      set({ approvingStaffMinute: false });
    }
  },

  checkStaffMinute: async (id, data = {}) => {
    set({ checkingStaffMinute: true, checkingStaffMinuteError: {}, checkedStaffMinute: null });
    try {
      const res = await axios.patch(`/administration/staff-minutes/check/${id}`, data);
      set({ checkedStaffMinute: res.data });
      get().getStaffMinutes();
      get().getStaffMinuteDetails(id);
    } catch (error) {
      set({ checkingStaffMinuteError: error });
    } finally {
      set({ checkingStaffMinute: false });
    }
  },

  setCreatingStaffMinute: (show = false, creating = false, record = null) => {
    set({
      showCreateStaffMinute: show,
      creating: creating,
      staffMinuteToEdit: record,
    });
  },

  setShowStaffMinuteDetails: (show = false, record = null) => {
    set({
      showStaffMinuteDetails: show,
      staffMinuteDetailsRecord: record,
    });
  },
});

const useStaffMinutesStore = create(devtools(store));
export default useStaffMinutesStore; 